<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
      <p class="title"><strong>Pesquisa</strong></p>
      <form class="mt-1 w-full" @submit.prevent="reloadTable">
        <div class="flex flex-wrap mb-4 px-4">
          <select-input
            v-model="filters.VisitingRules.type_rule"
            class="lg:pr-6 w-full lg:w-1/4"
            label="Tipo da regra" >
              <option :value="null" />
              <option
                v-for="(item) in type_rules_options"
                :key="item.name" :value="item.id">
                  {{ item.name }}
              </option>
          </select-input>

          <text-input
            v-model="filters.VisitingRules.visit_total"
            class="lg:pr-6 w-full lg:w-1/4"
            label="Número total de visitas" />

          <multi-select-input
            v-model="filters.VisitingRules.days_of_the_week_visit"
            :multiple="true"
            :options="daysOfWeekVisit"
            class="lg:pr-6 w-full lg:w-1/2"
            label="Dias da semana da visita" />

          <multi-select-input
            v-model="filters.VisitingRules.days_of_the_week_visit_required"
            :multiple="true"
            :options="daysOfWeekVisit"
            class="lg:pr-6 w-full lg:w-1/2"
            label="Dias da semana da visita" />

          <multi-select-input
            v-model="filters.VisitingRules.starts_on_weekday"
            :multiple="true"
            :options="daysOfWeekVisit"
            class="lg:pr-6 w-full lg:w-1/2"
            label="Inicia em" />

          <select-input
            v-model="filters.VisitingRules.interval_between_visits"
            class="lg:pr-6 w-full lg:w-1/2 lg:mt-4"
            label="Período de intervalo entre as visitas">
              <option :value="null" />
              <option v-for="(value, name, index) in interval_between_visits_options" :key="name" :value="name">
                {{ value }}
              </option>
          </select-input>

          <time-input
            v-model="filters.VisitingRules.time_start"
            class="lg:pr-6 w-full lg:w-1/4 lg:mt-4"
            label="Horário inicial" />

          <time-input
            v-model="filters.VisitingRules.time_end"
            class="lg:pr-6 w-full lg:w-1/4 lg:mt-4"
            label="Horário final" />

          <date-input
            v-model="filters.VisitingRules.date_start"
            class="lg:pr-6 w-full lg:w-1/4 lg:mt-4"
            label="Data de início" />

          <checkbox
            label="Ocultar tarefa futura"
            class="lg:pr-6 w-full lg:w-1/4 lg:mt-10"
            value="true"
            v-model="filters.VisitingRules.hide_future_task" />
        </div>

        <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
          <button
            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
              <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
              Pesquisar
          </button>

          <button class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100"
            @click="clearSearch">
              <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
              Limpar
          </button>
        </div>
      </form>
    </div>

    <Head title="Definição de regras" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Definição de regras</h1>
      <data-table v-if="loadTable" v-model:columns="columns" route="visiting_rules/list"
        :query="getQuery"
        no-data-label="Nenhuma regra cadastrada" no-result-label="Nenhuma regra encontrada">

        <template #table.cell.content.status_visiting="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.status_visiting="{ value, row }">
          <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.detail="{ value, row }">
          <div class="place-self-center grid-cols-2 gap-4">
            <span class="flex items-center justify-center text-sm">
              <Link :href="'brand/' + row.id" class="rounded p-2 bg-purple-100 text-white">
              Ver Marca<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
              </Link>
            </span>
          </div>
        </template>
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
            </span>
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" />Excluir
            </span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
            </span>
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
            </span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-purple uppercase"
            @click.prevent="openModalEdit({})">
              <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" />
              <span class="hidden lg:block">
                Adicionar Regra
              </span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit :modal-scrollable="true" ref="modalEdit" title="Regra" url="visiting_rules" @submitForm="reloadTable" id="modal-regra-visita">
      <template #form="{ item }">
        <radiobox label="Tipo da regra" class="lg:pr-6 w-full" :options="options" v-model="item.type_rule"
          required="true" />

        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Nome"
          required="true" />
        <mask-input class="lg:pr-6 w-full lg:w-1/2 mt-6" mask="##.###.###/####-##" v-model="item.visit_total" :error="item.errors.visit_total"
          label="Número total de visitas" required="true" />

        <textarea-input
            v-model="item.description"
            :error="item.errors.description"
            class="lg:pr-6 w-full lg:w-3/4 mb-3"
            label="Descrição"
         />

        <multi-select-input appendTo="#modal-regra-visita" v-if="item.type_rule == 1" v-model="item.days_of_the_week_visit" :multiple="true"
          :options="daysOfWeekVisit" :error="item.errors.days_of_the_week_visit" class="lg:pr-6 w-full lg:w-1/2 mt-6"
          label="Dias da semana da visita" required="true"/>

        <multi-select-input appendTo="#modal-regra-visita" v-if="item.type_rule == 1" v-model="item.days_of_the_week_visit_required"
          :options="week_options_all_computed" :error="item.errors.days_of_the_week_visit_required" class="lg:pr-6 w-full lg:w-1/2 mt-6"
          label="Dias obrigatórios"/>

        <select-input v-if="item.type_rule == 1" v-model="item.starts_on_weekday" :error="item.errors.starts_on_weekday"
          class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Inicia em" required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in week_options" :key="name" :value="name">{{ value }}</option>
        </select-input>

        <select-input v-if="item.type_rule == 1" v-model="item.interval_between_visits"
          :error="item.errors.interval_between_visits" class="lg:pr-6 w-full lg:w-1/2 mt-6"
          label="Período de intervalo entre as visitas" required="true">
          <option :value="null" />
          <option v-for="(value, name, index) in interval_between_visits_options" :key="name" :value="name">{{ value }}
          </option>
        </select-input>

        <time-input v-if="item.type_rule == 1" v-model="item.time_start" :error="item.errors.time_start"
          class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Horário inicial"/>
        <time-input v-if="item.type_rule == 1" v-model="item.time_end" :error="item.errors.time_end"
          class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Horário final"/>

        <date-input v-if="item.type_rule == 1" v-model="item.date_start" :error="item.errors.date_start"
          class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Data de início" required="true" />
        <date-input v-if="item.type_rule == 1" v-model="item.date_end" :error="item.errors.date_end"
          class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Data final" />

        <checkbox label="Ocultar tarefa futura" value="true" v-model="item.hide_future_task" class="mt-6"/>

      </template>

    </modal-edit>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import SwitchInput from '@/Shared/SwitchInput'
import DataTable from '@/Shared/DataTable'
import TextInput from '@/Shared/TextInput'
import MaskInput from '@/Shared/MaskInput'
import DateInput from '@/Shared/DateInput'
import TimeInput from '@/Shared/TimeInput'
import Checkbox from '@/Shared/CheckboxInput.vue'
import Radiobox from '@/Shared/RadioInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import VueSelectInput from '@/Shared/VueSelectInput'
import SelectInput from '@/Shared/SelectInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import { computed } from 'vue'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    Checkbox,
    Radiobox,
    MaskInput,
    DateInput,
    TimeInput,
    TextareaInput,
    VueSelectInput,
    SelectInput,
    MultiSelectInput,
    Link,
  },
  layout: Layout,
  data() {
    return {
      pesquisaSalva: true,

      options: [
        {
          label: 'Com regras especificas para visitas',
          value: 1,
          name: 'type_rule'
        },
        {
          label: 'Sem regras especificas para visitas',
          value: 2,
          name: 'type_rule'
        }
      ],
      loadTable: true,
      columns: [
        {
          uniqid: 'type',
          label: 'Tipo de Regra',
          field: 'type_rule',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.type_rule_label ? row.type_rule_label : ''
        },
        {
          uniqid: 'name',
          label: 'Nome',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'visit_total',
          label: 'TOTAL DE VISITAS',
          field: 'visit_total',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.visit_total ? row.visit_total : ''
        },
        {
          uniqid: 'days_of_the_week_visit',
          label: 'DIAS DA SEMANA',
          field: 'days_of_the_week_visit',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.days_of_the_week_visit ? row.days_of_the_week_visit.map(dia => dia.label).join(', ') : ''
        },
        {
          uniqid: 'days_of_the_week_visit_required',
          label: 'DIAS OBRIGATÓRIOS',
          field: 'days_of_the_week_visit_required',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.days_of_the_week_visit_required ? row.days_of_the_week_visit_required.map(dia => dia.label).join(', ') : ''
        },
        {
          uniqid: 'starts_on_weekday',
          label: 'DIA DE INICIO',
          field: 'starts_on_weekday',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.starts_on_weekday ? row.starts_on_weekday : ''
        },
        {
          uniqid: 'interval_between_visits',
          label: 'INTERVALO',
          field: 'interval_between_visits',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.interval_between_visits_label ? row.interval_between_visits_label : ''
        },
        {
          uniqid: 'time_end',
          label: 'Horário',
          field: 'time_end',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.time_start ? row.time_start + ' - ' + row.time_end : '',
        },
        {
          uniqid: 'status_visiting',
          label: 'STATUS',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  props: {
    week_options: Object,
    week_options_all: Array,
    type_rules_options: Array,
    daysOfWeekVisit: Array,
    interval_between_visits_options: Object,
  },
  computed: {
    week_options_all_computed: function() {
      let selectedDays = this.$refs.modalEdit.item.days_of_the_week_visit

      if ( selectedDays[ 0 ] && typeof( selectedDays[ 0 ] ) === 'object' )
        selectedDays = selectedDays.map( day => day.value )

      const daysRequiredOptions = this.daysOfWeekVisit.filter( day => selectedDays.includes( day.value ) )
      return daysRequiredOptions.map( day => ({ ...day, name: 'days_of_the_week_visit_required' }) )
    },

    getQuery() {
      return Object.entries( this.getFilters() ).map( ( [key, val] ) => `search2[${key}]=${val}` ).join( '&' )
    },
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/visiting_rules/update-status", item);
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/visiting_rules/${item.id}`, `Deseja realmente excluir a regra ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        visit_total: item.visit_total,
        starts_on_weekday: item.starts_on_weekday,
        days_of_the_week_visit: item.days_of_the_week_visit?.map(day_week => day_week.value) ?? [],
        days_of_the_week_visit_required: item.days_of_the_week_visit_required?.map(day_week => day_week.value) ?? [],
        interval_between_visits: item.interval_between_visits,
        time_start: item.time_start,
        description: item.description,
        time_end: item.time_end,
        date_start: item.date_start,
        date_end: item.date_end,
        hide_future_task: item.hide_future_task,
        type_rule: item.type_rule,
        errors: {}
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    clearSearch() {
      this.clearFilters()
      this.reloadTable();
    },
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent( 'VisitingRules' )

    const clearFilters = () => clearFiltersComponent( 'VisitingRules' )
    const getFilters = () => getFiltersComponent( 'VisitingRules' )

    return {
      getFilters,
      clearFilters,
      filters: filtersStore.filters
    }
  }
}
</script>
